import { placeholderPaths } from "@/lib/shared/constants";
import type { GiftSet } from "./types";

export type GiftSetCardImage = { src: string; alt: string };

function firstProductGalleryImage(
  product: GiftSet["products"][number]["product"],
  displayTitle: string,
): GiftSetCardImage {
  const primary = product.images?.[0];
  const src = (primary?.src ?? "").trim();
  if (src) {
    return {
      src,
      alt: (primary?.alt ?? "").trim() || product.name?.trim() || displayTitle,
    };
  }
  return {
    src: placeholderPaths.image,
    alt: product.name?.trim() || displayTitle,
  };
}

/** Primary card image: first gallery image of the first product, else cover/placeholder. */
export function resolveGiftSetCardImage(giftSet: GiftSet): GiftSetCardImage {
  const title = giftSet.displayTitle;
  const firstProduct = giftSet.products[0]?.product;
  if (firstProduct) {
    return firstProductGalleryImage(firstProduct, title);
  }

  const cover = giftSet.coverImage;
  const src = (cover?.src ?? "").trim() || placeholderPaths.image;
  const alt = (cover?.alt ?? "").trim() || title;
  return { src, alt };
}
